// src/App.js
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Navbar from './components/Navbar/Navbar';
import Home from './pages/Home/Home';
import AboutUs from './pages/AboutUs/AboutUs';
import Products from './pages/Products/Products';
import AllProducts from './pages/AllProducts/AllProducts';
import Testimonials from './pages/Testimonials/Testimonials';
import Certification from './pages/Certifications/Certifications';
import ContactUs from './pages/ContactUs/ContactUs';
import Footer from './components/Footer/Footer';
import BackToTop from './components/BackToTop/BackToTop';
import AdminLogin from './admin/AdminLogin/AdminLogin';
import AdminDashboard from './admin/AdminDashboard/AdminDashboard';
import AddProduct from './admin/AddProduct/AddProduct';
import EditProduct from './admin/EditProduct/EditProduct';
import ProtectedRoute from './admin/ProtectedRoute/ProtectedRoute';

// ✅ Layout inside Router context
const Layout = ({ children }) => {
  const location = useLocation();
  const hideNavbar = location.pathname.startsWith('/admin') && location.pathname !== '/admin/dashboard';

  return (
    <>
      {/* ✅ Fallback SEO for all routes */}
      <Helmet>
        <title>UBR Engineering Works | Precision Machinery</title>
        <meta name="description" content="UBR Engineering Works manufactures high-performance industrial machinery for every engineering need." />
        <meta name="keywords" content="engineering machinery, UBR Engineering" />
        <meta name="author" content="UBR Engineering Works" />
      </Helmet>

      {!hideNavbar && <Navbar />}
      <main>{children}</main>
      <BackToTop />
    </>
  );
};

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="*"
          element={
            <Layout>
              <Routes>
                <Route
                  path="/"
                  element={
                    <>
                      <Home />
                      <AboutUs />
                      <Products />
                      <Testimonials />
                      <Certification />
                      <ContactUs />
                      <Footer />
                    </>
                  }
                />
                <Route path="/all-products" element={<AllProducts />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route
                  path="/admin/dashboard"
                  element={
                    <ProtectedRoute>
                      <AdminDashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/add-product"
                  element={
                    <ProtectedRoute>
                      <AddProduct />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/edit/:id"
                  element={
                    <ProtectedRoute>
                      <EditProduct />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </Layout>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
